module.exports = __webpack_public_path__ + "media/images/icon__info--white@3x-79e2e944670e82ec5aa742d9a2f9538f.png";